import { render, staticRenderFns } from "./safety-inventory-add.vue?vue&type=template&id=3c371571&scoped=true&"
import script from "./safety-inventory-add.vue?vue&type=script&lang=ts&"
export * from "./safety-inventory-add.vue?vue&type=script&lang=ts&"
import style0 from "./safety-inventory-add.vue?vue&type=style&index=0&id=3c371571&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c371571",
  null
  
)

export default component.exports